import { application } from "./application"

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import MatrixFormController from "./matrix_form_controller"
application.register("matrix-form", MatrixFormController)

import JsonEditorController from "./json_editor_controller"
application.register("json-editor", JsonEditorController)